export default __webpack_public_path__ + "static/aws-cloud-20140cf3acf8f2be323165cce290194d.svg";